/**
 * Les sous-onglets de « Ce qui a été vu » dans la fiche d'un enfant.
 *
 * Hedi, le 27 septembre 2026 : *« Dans ce qui a été vu je veux deux sous-tabs :
 * le courant ; un sous tab où par matières, les chapitres sont affichés et les
 * compétences sont sous ces chapitres »*, puis *« Chapitres des ouvrages quand
 * c'est disponible. Sinon Thèmes du programme. »*
 *
 * **Un seul écran, deux rangements.** Les deux sous-onglets montent
 * `VuEnClasseScreen` : cocher dans l'un doit se lire dans l'autre, et c'est
 * toujours la même route qui déclare. L'adresse d'origine reste celle de la
 * liste — `ui/planDuSoir` et le tableau de bord y mènent déjà.
 *
 * L'onglet « Ce qui a été vu » de `ChildLayout` s'allume sur les deux adresses
 * par préfixe, sans `aussi`.
 */

import { Outlet, useParams } from "react-router-dom";

import { SousOnglets } from "@/ui/SousOnglets";

export function VuEnClasseLayout() {
  const { childId = "" } = useParams();
  const base = `/parents/enfant/${childId}/vu-en-classe`;

  const tabs = [
    { to: base, label: "Liste", end: true },
    { to: `${base}/par-chapitre`, label: "Par chapitre" },
    // Les pages du cahier de classe photographiées en fin de semaine, et ce
    // que la lecture en a reconnu (lot P5) : une preuve de plus de ce qui a
    // été traité, et les blocages de la semaine.
    { to: `${base}/cahier-semaine`, label: "Le cahier de la semaine" },
  ];

  return (
    <>
      <SousOnglets tabs={tabs} label="Ce qui a été vu" />
      <Outlet />
    </>
  );
}
